import { Button, Container, Grid, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import './styles.css'
import { editUser, getUserById } from '../../api'
import Cookies from 'universal-cookie';
import moment from 'moment';
import { useFormik } from 'formik';
import Snackbars from '../../components/snackbar';

function Profile() {
    const cookie = new Cookies()
    const [user, setUser] = useState([])
    const [successopen, setSuccessOpen] = useState(false);
    const [pass, setPass] = useState('');
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessOpen(false);
    };

    useEffect(() => {
        const user = getUserById(cookie.get('id'))
        user.then(response => {
            setUser(response.data)
            setPass(response.data.password)
        })
    }, [])


    const formik = useFormik({
        initialValues: {
            password: pass,
        },
        onSubmit: () => { }
    });
    const func = () => {
        if (user) {
            const data = {
                password: pass,
            }

            const updateUser = editUser(user._id, data)
            updateUser.then(response => {
                if (response.success) {
                    setSuccessOpen(true);
                } else {
                    alert(response.message)
                }
            })
        }

    }

    return (
        <Container>
            <Grid container fluid style={{ height: "calc(100vh - 69px)" }}>
                <Grid lg={12} md={12} sm={12} xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div className='profileWrapper'>
                        <div className='profileContainer'>
                            <div className='profileTitleContainer'>
                                <p className='profileTitle'>Profile</p>
                            </div>
                            <div style={{ padding: 16 }}>
                                <div className='nameInputContainer'>
                                    <div>
                                        <p>First Name</p>
                                        <input
                                            size="small"
                                            disabled
                                            id="outlined-basic"
                                            value={user.firstName}
                                            variant="outlined"
                                            className='profileinputDisabled'
                                            style={{ width: "100%" }} />
                                    </div>
                                    <div style={{ marginLeft: 16 }}>
                                        <p>Last Name</p>
                                        <input
                                            size="small"
                                            disabled
                                            id="outlined-basic"
                                            value={user.lastName}
                                            variant="outlined"
                                             className='profileinputDisabled'
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </div>
                                <div className='emailInputContainer'>
                                    <div>
                                        <p>Email</p>
                                        <input
                                            size="small"
                                            fullwidth
                                            disabled
                                            id="outlined-basic"
                                            value={user.email}
                                            variant="outlined"
                                             className='profileinputDisabled'
                                            style={{ width: "100%" }} />
                                    </div>
                                    <div style={{ marginLeft: 16 }}>
                                        <p>Username</p>
                                        <input
                                            size="small"
                                             className='profileinputDisabled'
                                            disabled
                                            id="outlined-basic"
                                            value={user.username}
                                            variant="outlined"
                                            style={{ width: "100%" }} />
                                    </div>
                                </div>
                                <div className='nameInputContainer'>
                                    <div>
                                        <p>Birthdate</p>
                                        <input
                                            size="small"
                                            disabled
                                             className='profileinputDisabled'
                                            id="outlined-basic"
                                            value={moment(user.birthdate).format('L')}
                                            variant="outlined"
                                            style={{ width: "100%" }} />
                                    </div>
                                    <div style={{ marginLeft: 16 }}>
                                        <p>Phone Number</p>
                                        <input
                                            size="small"
                                            disabled
                                             className='profileinputDisabled'
                                            id="outlined-basic"
                                            value={user.phone}
                                            variant="outlined"
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </div>
                                <div className='nameInputContainer'>
                                    <div>
                                        <p>Wallet</p>
                                        <input
                                            size="small"
                                            fullwidth
                                            disabled
                                             className='profileinputDisabled'
                                            id="outlined-basic"
                                            value={user.wallet}
                                            variant="outlined"
                                            style={{ width: "100%" }} />
                                    </div>
                                    <div style={{ marginLeft: 16, display: 'flex'  , position:"relative" , zIndex:"1"}}>
                                        <div>
                                            <p>Password</p>
                                            <input
                                                style={{
                                                    background:'transparent',
                                                    fontSize: 14,
                                                    height: '40px',
                                                    borderRadius: 100,
                                                    border: '1px solid var(--white)',
                                                    color: 'var(--white)',
                                                    paddingLeft:8
                                                }}
                                                type="text"
                                                id="password"
                                                name="password"
                                                onChange={(e) => setPass(e.target.value)}
                                                value={pass}
                                            />
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                                            <Button
                                                style={{color:"var(--white)" , backgroundColor:"var(--green)", borderRadius:"100px"}}
                                                onClick={() => func()}
                                            >
                                                Edit
                                            </Button>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </Grid>
            </Grid>
            <Snackbars
                open={successopen}
                text="Password changed"
                severity="success"
                duration={3000}
                close={handleClose} />
        </Container>
    )
}

export default Profile